import { Link } from 'react-router-dom';
import { useState } from 'react';

const heroSlides = [
  {
    id: 1,
    title: '阿凡达3：火与烬',
    subtitle: '全新世界 · 史诗归来',
    description: '杰克和奈提莉在潘多拉星球上面临新的威胁，遇见以火为生的纳美人部落',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20scene%20with%20alien%20planet%20landscape%2C%20volcanic%20mountains%2C%20bioluminescent%20forest%2C%20grand%20scale%2C%20dramatic%20golden%20and%20red%20lighting%2C%20fantasy%20world%2C%20widescreen%20movie%20poster%20quality&width=1600&height=700&seq=hero-slide-1&orientation=landscape',
    movieId: 'movie-12',
    category: '科幻片',
  },
  {
    id: 2,
    title: '封神第二部：战火西岐',
    subtitle: '神话史诗 · 燃情巨制',
    description: '殷商大军兵临西岐，姜子牙率众将士迎战，一场关乎天下命运的史诗之战',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20with%20ancient%20warriors%20in%20armor%2C%20massive%20army%2C%20dramatic%20stormy%20sky%2C%20cinematic%20lighting%2C%20grand%20scale%2C%20golden%20and%20red%20tones&width=1600&height=700&seq=hero-slide-2&orientation=landscape',
    movieId: 'movie-5',
    category: '动作片',
  },
  {
    id: 3,
    title: '哪吒之魔童闹海',
    subtitle: '我命由我 · 再战乾坤',
    description: '天劫之后，哪吒与敖丙灵魂虽保但肉身濒危，七色宝莲能否重塑其身',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20scene%20with%20mythological%20boy%20warrior%2C%20flaming%20elements%2C%20dramatic%20thunder%20sky%2C%20vibrant%20red%20and%20gold%20colors%2C%20epic%20scale%2C%20cinematic%20quality&width=1600&height=700&seq=hero-slide-3&orientation=landscape',
    movieId: 'movie-4',
    category: '动画片',
  },
];

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[currentSlide];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="精选推荐">
      {heroSlides.map((s, index) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-800 ease-in-out ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={s.imageUrl}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-[1400px] mx-auto">
            <div className="max-w-2xl">
              <span className="inline-block px-3 py-1 rounded-md text-xs font-medium bg-accent-500/90 text-white mb-4">
                {slide.category}
              </span>
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3 leading-tight">
                {slide.title}
              </h2>
              <p className="text-lg md:text-xl text-primary-400 font-medium mb-4">
                {slide.subtitle}
              </p>
              <p className="text-foreground-300 text-sm md:text-base mb-6 max-w-lg leading-relaxed">
                {slide.description}
              </p>
              <div className="flex items-center gap-3 flex-wrap">
                <Link
                  to={`/movie/${slide.movieId}`}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  立即观看
                </Link>
                <Link
                  to={`/category/${slide.category === '科幻片' ? 'scifi' : slide.category === '动作片' ? 'action' : 'animation'}`}
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-lg border border-foreground-300/30 text-foreground-200 text-sm font-medium hover:bg-foreground-100/10 transition-colors cursor-pointer whitespace-nowrap"
                >
                  更多{slide.category}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-primary-500 w-6'
                : 'bg-foreground-300/50 hover:bg-foreground-300/80'
            }`}
            aria-label={`切换到第${index + 1}张图片`}
          />
        ))}
      </div>
    </section>
  );
}